import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { setShowAIFeedbackModal } from "../../redux/actions/reports/reportsAction";

export const AIFeedbackModal = ({ id, data }) => {
    const { showAIFeedback } = useSelector((state) => state.report);
    const dispatch = useDispatch();

    const toggle = () => {
        dispatch(setShowAIFeedbackModal({ [id]: false }));
    };

    const feedback = typeof data === 'string' ? JSON.parse(data) : data;

    // Detect if text is Arabic by checking for Arabic characters
    const isArabicText = (text) => {
        if (!text) return false;
        const arabicRegex = /[\u0600-\u06FF]/;
        return arabicRegex.test(text);
    };

    // Check the summary to determine language
    const isArabic = isArabicText(feedback?.summary);

    // Language-specific labels
    const labels = {
        english: {
            title: "AI Feedback Details",
            summary: "📋 Summary",
            modifications: "✅ Recommended Modifications",
            risks: "⚠️ Identified Risks",
            close: "Close"
        },
        arabic: {
            title: "تفاصيل تقييم الذكاء الاصطناعي",
            summary: "📋 الملخص",
            modifications: "✅ التعديلات الموصى بها",
            risks: "⚠️ المخاطر المحددة",
            close: "إغلاق"
        }
    };

    const currentLabels = isArabic ? labels.arabic : labels.english;

    return (
        <>
            {showAIFeedback[id] && feedback && (
                <Modal 
                    isOpen={showAIFeedback[id]} 
                    toggle={toggle} 
                    centered={true}
                    size="lg"
                    className="large-pop adding-popup"
                    style={{ maxHeight: '90vh' }}
                >
                    <ModalHeader toggle={toggle}>
                        {currentLabels.title}
                    </ModalHeader>
                    <ModalBody style={{ 
                        maxHeight: '70vh', 
                        overflowY: 'auto',
                        padding: '20px'
                    }}>
                        <div style={{ 
                            direction: isArabic ? 'rtl' : 'ltr',
                            textAlign: isArabic ? 'right' : 'left'
                        }}>
                            {/* Summary Section */}
                            {feedback.summary && (
                                <div style={{ marginBottom: '30px' }}>
                                    <h5 style={{ 
                                        color: '#2c3e50', 
                                        borderBottom: '2px solid #3498db',
                                        paddingBottom: '12px',
                                        marginBottom: '18px',
                                        fontWeight: '600',
                                        fontSize: '1.3rem'
                                    }}>
                                        {currentLabels.summary}
                                    </h5>
                                    <p style={{ 
                                        lineHeight: '1.8', 
                                        color: '#34495e',
                                        backgroundColor: '#f8f9fa',
                                        padding: '18px',
                                        borderRadius: '6px',
                                        border: '1px solid #e9ecef',
                                        fontSize: '1.2rem',
                                        margin: 0
                                    }}>
                                        {feedback.summary}
                                    </p>
                                </div>
                            )}

                            {/* Modifications Section */}
                            {feedback.modifications && feedback.modifications.length > 0 && (
                                <div style={{ marginBottom: '30px' }}>
                                    <h5 style={{ 
                                        color: '#27ae60', 
                                        borderBottom: '2px solid #27ae60',
                                        paddingBottom: '12px',
                                        marginBottom: '18px',
                                        fontWeight: '600',
                                        fontSize: '1.3rem'
                                    }}>
                                        {currentLabels.modifications}
                                    </h5>
                                    <ul style={{ 
                                        lineHeight: '1.9', 
                                        color: '#34495e',
                                        paddingLeft: isArabic ? '0' : '25px',
                                        paddingRight: isArabic ? '25px' : '0',
                                        margin: 0,
                                        listStylePosition: isArabic ? 'inside' : 'outside'
                                    }}>
                                        {feedback.modifications.map((mod, index) => (
                                            <li key={index} style={{ 
                                                marginBottom: '15px',
                                                paddingLeft: isArabic ? '0' : '8px',
                                                paddingRight: isArabic ? '8px' : '0',
                                                fontSize: '1.2rem'
                                            }}>
                                                {mod}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {/* Risks Section */}
                            {feedback.risks && feedback.risks.length > 0 && (
                                <div style={{ marginBottom: '20px' }}>
                                    <h5 style={{ 
                                        color: '#e74c3c', 
                                        borderBottom: '2px solid #e74c3c',
                                        paddingBottom: '12px',
                                        marginBottom: '18px',
                                        fontWeight: '600',
                                        fontSize: '1.3rem'
                                    }}>
                                        {currentLabels.risks}
                                    </h5>
                                    <ul style={{ 
                                        lineHeight: '1.9', 
                                        color: '#34495e',
                                        paddingLeft: isArabic ? '0' : '25px',
                                        paddingRight: isArabic ? '25px' : '0',
                                        margin: 0,
                                        listStylePosition: isArabic ? 'inside' : 'outside'
                                    }}>
                                        {feedback.risks.map((risk, index) => (
                                            <li key={index} style={{ 
                                                marginBottom: '15px',
                                                backgroundColor: '#fff5f5',
                                                padding: '15px',
                                                borderRadius: '6px',
                                                borderLeft: isArabic ? 'none' : '4px solid #e74c3c',
                                                borderRight: isArabic ? '4px solid #e74c3c' : 'none',
                                                fontSize: '1.2rem'
                                            }}>
                                                {risk}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>
                            {currentLabels.close}
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
        </>
    );
};